/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {declaration as ɵa} from './ruledefinition.module';
export {RuleDefinitionRoutes as ɵb} from './ruledefinition.routing';